import { emit } from "../adManage/adManage";
import { render } from "../render";
import { debounce } from "../utils/debounce";
import { repo } from "../adManage/adAction";
const didStore = new Map();
export class Did {
    get isView() {
        return this._isView;
    }
    set isView(value) {
        if (value) {
            repo({
                repoType: "view",
                placeCode: this.placeCode,
                adUnitId: this.adContent.adUnitId,
                loadTime: this.loadTime,
                ssnId: this.adContent.ssnId,
            });
        }
        this._isView = value;
    }
    get isExpenses() {
        return this._isExpenses;
    }
    set isExpenses(value) {
        if (value) {
            repo({
                repoType: "exposure",
                placeCode: this.placeCode,
                adUnitId: this.adContent.adUnitId,
                loadTime: this.loadTime,
                ssnId: this.adContent.ssnId,
            });
        }
        this._isExpenses = value;
    }
    get isClick() {
        return this._isClick;
    }
    set isClick(value) {
        if (value) {
            repo({
                repoType: "click",
                placeCode: this.placeCode,
                adUnitId: this.adContent.adUnitId,
                loadTime: this.loadTime,
                ssnId: this.adContent.ssnId,
            });
        }
        this._isClick = value;
    }
    constructor(html, option) {
        this._isView = false;
        this._isExpenses = false;
        this._isClick = false;
        this.rwdd = 0;
        this.instl = 0;
        this.autoPull = true;
        this.type = "banner";
        this.isPull = false;
        this.loop = true;
        this.isClosed = false;
        this.loadTime = null;
        this.isPlay = false;
        this.isPlayed = false;
        this.isVisible = false;
        this.onError = debounce(() => { });
        try {
            if (!html) {
                throw new Error("html is required");
            }
            this.html = html;
            if (!option.placeCode) {
                throw new Error("placeCode is required");
            }
            else {
                this.placeCode = option.placeCode;
            }
            if (option.zIndex) {
                this.zIndex = option.zIndex;
            }
            if (option.onClose) {
                this.onClose = option.onClose;
            }
            if (option.onOver) {
                this.onOver = option.onOver;
            }
            if (option.onStop) {
                this.onStop = option.onStop;
            }
            if (option.onPull) {
                this.onPull = option.onPull;
            }
            if (option.onStart) {
                this.onStart = option.onStart;
            }
            if (option.onPlay) {
                this.onPlay = option.onPlay;
            }
            if (option.onError) {
                this.onError = debounce(option.onError);
            }
            if (option.onClick) {
                this.onClick = option.onClick;
            }
            let timer = null;
            this.html.addEventListener("resize", () => {
                this.width = html.clientWidth;
                this.height = html.clientHeight;
                if (this.autoPull && !this.isPlay) {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        this.stop();
                        this.pullAd();
                    }, 500);
                }
            });
            this.width = html.clientWidth;
            this.height = html.clientHeight;
            const observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    this.isVisible = true;
                    if (this.autoPull && !this.isPlay && this.isPull && !this.isClosed) {
                        this.render();
                    }
                }
                else {
                    this.isVisible = false;
                }
            });
            observer.observe(this.html);
            if (this.autoPull) {
                this.pullAd();
            }
        }
        catch (error) {
            this.onError && this.onError(error);
            console.log(error);
        }
    }
    pullAd() {
        try {
            let number = 0;
            const emits = () => {
                const start = Date.now();
                emit("pullAd", {
                    placeCode: this.placeCode,
                })
                    .then((res) => {
                    const end = Date.now();
                    this.loadTime = parseInt(((end - start) / 1000).toString());
                    this.adContent = res;
                    this.isPull = true;
                    this.onPull && this.onPull();
                    if (this.isVisible) {
                        this.render();
                    }
                })
                    .catch((err) => {
                    this.onError && this.onError(err);
                    if (number < 5) {
                        number++;
                        setTimeout(() => {
                            emits();
                        }, 5000);
                    }
                });
            };
            emits();
        }
        catch (error) {
            this.onError && this.onError(error);
        }
    }
    render() {
        const _this = this;
        const option = {
            type: _this.type,
            loop: _this.loop,
            adContent: _this.adContent,
            width: _this.width,
            height: _this.height,
            placeCode: _this.placeCode,
            zIndex: _this.zIndex,
            onClose() {
                _this.isPlay = false;
                _this.isPlayed = true;
                _this.isClosed = true;
                _this.stop();
                _this.onClose && _this.onClose();
            },
            onOver() {
                _this.onOver && _this.onOver();
                if (!_this.loop) {
                    _this.stop();
                    _this.isPlayed = true;
                }
                else {
                    _this.isPlayed = false;
                }
            },
            onStart() {
                _this.isPlay = true;
                _this.onStart && _this.onStart();
            },
            onStop() {
                _this.isPlay = false;
            },
            onError(err) {
                _this.isPlay = false;
                _this.isPlayed = false;
                console.error(err, "err");
                _this.onError && _this.onError(err);
            },
            onView() {
                _this.isView = true;
            },
            onExposure() {
                _this.isExpenses = true;
            },
            onClick() {
                if (!_this.isExpenses) {
                    _this.isExpenses = true;
                }
                _this.isClick = true;
                _this.onClick && _this.onClick();
            },
        };
        const dom = render(option);
        this.onPlay && this.onPlay();
        setTimeout(() => {
            this.html.appendChild(dom);
        });
    }
    play() {
        if (!this.isPull) {
            this.pullAd();
        }
        else {
            this.render();
        }
    }
    stop() {
        this.html.innerHTML = "";
    }
}
export const push = (html, option) => {
    const did = new Did(html, option);
    didStore.set(option.placeCode, did);
    return did;
};
export const deleted = (placeCode) => {
    if (didStore.get(placeCode)) {
        didStore.delete(placeCode);
    }
    else {
        console.error("当前dom不存在广告位");
    }
};
export const get = (placeCode) => {
    if (didStore.get(placeCode)) {
        return didStore.get(placeCode);
    }
    else {
        console.error("该dom未使用广告位");
    }
};
export const getAll = () => {
    return Array.from(didStore.values());
};
//# sourceMappingURL=didStore.js.map